import type { IconProps } from '../types/IconProps.ts';
export const CalendarDays: IconProps = {
    name: 'CalendarDays',
    children: [
        `<path d="M19 4H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M8 2v4M16 2v4M3 10h18" />`,
        `<circle cx="8" cy="14" r=".5" />`,
        `<circle cx="8" cy="18" r=".5" />`,
        `<circle cx="12" cy="18" r=".5" />`,
        `<circle cx="16" cy="18" r=".5" />`,
        `<circle cx="12" cy="14" r=".5" />`,
        `<circle cx="16" cy="14" r=".5" />`,
    ]
};